var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-content',{attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm.redirectingInfoText)+" ")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }